import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

// Generic pill-button + floating-menu dropdown — same look/behavior as the
// project filter on Usage History (src/pages/superAdmin/UsageHistory.jsx).
// `options` is [{ value, label }]. Used for any single-select list filter
// (project, status, ...) so all super-admin list pages look consistent.
const FilterDropdown = ({ options, value, onChange, icon: Icon, minWidth = 180 }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, right: 0 });
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) &&
          btnRef.current && !btnRef.current.contains(e.target))
        setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const toggle = () => {
    if (!open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + window.scrollY + 6, right: window.innerWidth - rect.right });
    }
    setOpen((o) => !o);
  };

  const selectedLabel = options.find((o) => o.value === value)?.label ?? options[0]?.label ?? "";

  return (
    <div style={{ position: "relative", flexShrink: 0 }}>
      <button
        ref={btnRef}
        type="button"
        style={{
          display: "flex", alignItems: "center", gap: 8, minWidth, maxWidth: "100%",
          padding: "6px 12px", background: "#fff", border: "1px solid #e2e8f0",
          borderRadius: 8, fontSize: 14, color: "#212529", cursor: "pointer",
          height: 42, outline: "none", boxShadow: "none",
        }}
        onClick={toggle}
      >
        {Icon && <Icon size={14} style={{ flexShrink: 0, color: "#64748b" }} />}
        <span style={{ flex: 1, textAlign: "left", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {selectedLabel}
        </span>
        <ChevronDown size={13} style={{ flexShrink: 0, color: "#64748b", transition: "transform .2s", transform: open ? "rotate(180deg)" : "rotate(0deg)" }} />
      </button>

      {open && (
        <div ref={menuRef} style={{
          position: "fixed", top: pos.top, right: pos.right, zIndex: 99999,
          background: "#fff", border: "1px solid #dee2e6", borderRadius: 6,
          boxShadow: "0 2px 8px rgba(15,23,42,.12)", minWidth: 220, maxHeight: 320, overflowY: "auto",
        }}>
          {options.map((o) => {
            const isActive = value === o.value;
            return (
              <div
                key={o.value}
                onMouseDown={() => { onChange(o.value); setOpen(false); }}
                style={{
                  padding: "7px 12px", cursor: "pointer", fontSize: 14,
                  color: isActive ? "#fff" : "#212529",
                  background: isActive ? "var(--primaryColor)" : "transparent",
                }}
                onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = "#e8f0fe"; }}
                onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = "transparent"; }}
              >
                {o.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
